import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Backdrop,
  CircularProgress,
  Dialog,
} from "@material-ui/core";
// import StyledButton from "../../models/Button";
// import StyledButton from "../models/Button";
import StyledButton from "../../../common/models/Button";
//import CheckBoxButton from "../../CheckboxAndButton";
// import Accordion from '../RejectedRecordAccordion';
// import StyledButton from '../../../../common/models/Button';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
//import RejectedRecordAccordionModel from "../../RejectedRecordAccordion";
import axios from "axios";
// import { appUrl } from "../../../../../../utils/config";
import { appUrl } from "../../../../utils/config";
// import StyaledDialog from "./StyledDialog";
// import StyaledDialog from "../InventoryStatus/InventoryReconciliation/StyledDialog";
import StyledDialog from "../../../common/models/Dialog";
import jwtDecode from "jwt-decode";
const useStyles = makeStyles((theme) => ({
  container: { textAlign: "center", padding: "1rem" },
  errorBox: {
    border: "1px solid red",
    backgroundColor: "#FFF0F0",
    padding: "0.8rem",
  },
  itemGrid: {
    border: "2px solid #707070",
    padding: "1rem",
  },
  number: { fontSize: "2.4rem", fontWeight: 500 },
  // buttonContainer: { textAlign: "center", marginTop: "2rem" },

  // buttonContainer: {
  //   display: "flex", // Enable Flexbox
  //   justifyContent: "center", // Center the content horizontally
  //   alignItems: "center", // Center the content vertically (if needed)
  //   gap: theme.spacing(2), // Add some spacing between buttons (optional)
  //   marginTop: theme.spacing(3), // Add top margin (optional)
  // },
  // reUploadButton: {
  //   marginRight: "auto",
  //   textDecoration: "underline",
  //   cursor: "pointer",
  // },
  buttonContainer: {
    display: "flex",
    justifyContent: "center", // Centers the button group horizontally
    marginTop: theme.spacing(3),
    width: "100%",
  },
  reUploadButton: {
    marginRight: "auto",
    alignSelf: "flex-start",
    textDecoration: "underline",
    cursor: "pointer",
    textTransform: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  // rejectedRecord: {
  //   display: "flex",
  //   flexDirection: "column",
  // },
}));

const ValidateRecord = ({
  handleBack,
  validationData,
  handleClose,
  fetchReasonCodes,
   addSponsorList, rowData,updateNetworkData,rowNetwork,networkType,networkTypeUrl,setReasonCodesData
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dialog, setDialog] = useState("");

  const getDataFromAuthToken = () => {
    const token = localStorage.getItem("authToken");
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };
   const network= networkType || addSponsorList?.data?.network || rowNetwork;
   const networkUrl=networkTypeUrl || updateNetworkData?.ecosystemUrl || rowData?.networkURL;
  const { email_address, organization_id } = getDataFromAuthToken();

  const handleSubmit = () => {
    
    
    if (
      !validationData ||
      !validationData.validRecords ||
      validationData.validRecords.length === 0
    ) {
      console.error("No valid records to submit.");
      return;
    }

    const payload = {
      lastUpdatedBy: email_address,
      sponsorId: 2, // Example sponsorId
      ecosystemId: 1,
      reasonCodeList: validationData?.validRecords.map((record) => ({
        // materialCode: record["CMO Material Code"],
        // materialDescription: record["CMO Material Description"],
        // inventoryBatchNumber: record["CMO Batch Number"],
        // quantityOnHand: record["Quantity on Hand"],
        // allocatedQuantity: record["Allocated Quantity"],
        // netAvailableQuantity: record["Net Quantity"],
        // inventoryUOM: record["CMO UOM"],
        // vendorPlant: record["CMO Plant ID"],
        // storageLocationID: record["Storage Location ID"],
        // dataCollectionTimestamp: record["Data Collection Timestamp"],
        // inventoryExpiryDate: record["Expiry Date"],
        reasonDescription: record["Reason code description"],
        reasonCodeType: record["Reason code type"],
        reasonCodeGroupType: record["Code group type"],
        reasonCode: record["Reason code"],
        reasonCodeGroup: record["Code group"],
        status: record["Status"],
        Visibletoorg: record["Visible to org"],
      })),
    };
    setLoading(true);
    setError(null);
    const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateReasonCodes`;

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status) {
          setDialog("success");
          fetchReasonCodes();
          setReasonCodesData((prev) => !prev);
        }
      })
      .catch((err) => {
        console.error("Error: ", err.message || "Something went wrong");
        setError(err.message || "Something went wrong");
        setDialog("error");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // const handleClose=()=>{

  //   setDialog(null)
  // }

  return (
    <Container container justify="center" className={classes.container} style={{padding: "0"}}>
      <Typography variant="h5" style={{ marginBottom: "1em" }}>
        Validation Summary
      </Typography>

      {/* Summary of Records */}
      <Grid container spacing={3} justify="space-between">
        {[
          {
            label: "Total Records",
            value:
              validationData?.validRecordsCount +
              validationData?.invalidRecordsCount,
          },
          { label: "Valid Records", value: validationData?.validRecordsCount },
          {
            label: "Rejected Records",
            value: validationData?.invalidRecordsCount,
          },
        ].map(({ label, value }, index) => (
          <Grid item xs={12} sm={3} key={index}>
            <Box className={classes.itemGrid}>
              <Typography>{label}</Typography>
              <Typography className={classes.number}>{value}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Rejected Records */}
      {validationData?.invalidRecordsCount > 0 && (
        <Grid item xs={12}>
          <Box width="100%" style={{ margin: "1em 0" }}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2">Rejected record(s)</Typography>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flexStart",
                  textAlign: "left",
                }}
              >
                {validationData.invalidRecords.map((records, recordIndex) => (
                  <React.Fragment key={recordIndex}>
                    {records.errors.map((error, errorIndex) => (
                      <Typography
                        key={`${recordIndex}-${errorIndex}`}
                        variant="body1"
                        gutterBottom
                        display="block"
                      >{`Row ${records?.row} - ${error}`}</Typography>
                    ))}
                    <br />
                  </React.Fragment>
                ))}
              </AccordionDetails>
            </Accordion>
          </Box>
        </Grid>
      )}

      <Box className={classes.buttonContainer}>
        <Button className={classes.reUploadButton} onClick={handleBack}>
          &lt; Re-upload File
        </Button>
        <StyledButton
          endIcon={<ChevronRightIcon />}
          disabled={validationData?.invalidRecordsCount ? true : false}
          onClick={handleSubmit}
        >
          Submit Records
        </StyledButton>
      </Box>
      {loading && (
        <Backdrop
          className={classes.backdrop}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog open={dialog} fullWidth={true} maxWidth="xs">
        {dialog === "error" ? (
          <StyledDialog
            handleClose={() => setDialog(null)}
            icon={true}
            title="Failed"
            subtitle="Something went wrong. Please try again later."
          />
        ) : (
          dialog === "success" && (
            <StyledDialog
              handleClose={handleClose}
              icon={false}
              title="Details Saved Successfully"
              subtitle={<>
                Your record has been added/updated. <br/>
Please contact admin if you have entered the wrong data.
              </>}
            />
          )
        )}
      </Dialog>
    </Container>
  );
};

export default ValidateRecord;
